import { Input } from "@/app/admin/_common/ui/input";
import CuoButton from "@/app/admin/_common/CuoButton";
import { Can } from "@/app/admin/_common/Can";
import { PERMISSIONS } from "@/app/_utils/permissions";
import { Plus, Search } from "lucide-react";

export default function RolesToolbar({
  search,
  onSearchChange,
  onNewRole,
}: {
  search: string;
  onSearchChange: (value: string) => void;
  onNewRole: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 pb-3">
      <div className="relative min-w-[200px] flex-1">
        <span className="pointer-events-none absolute inset-y-0 left-2.5 flex items-center">
          <Search className="size-3.5 text-muted-foreground" />
        </span>
        <Input
          className="pl-8"
          placeholder="Search roles"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </div>

      <Can permission={PERMISSIONS.RBAC_ROLES_WRITE}>
        <CuoButton icon={<Plus className="size-4" />} onClick={onNewRole} label="New role" />
      </Can>
    </div>
  );
}
